import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Province } from '@ascschool/model/category/province.model';
import { GroupManage } from '@ascschool/model/user/groupmanage.model';
import { ProvinceService } from '@ascschool/services/category/province.service';
import { GroupManagerService } from '@ascschool/services/user/group-manager.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-popup-nqt.component',
  templateUrl: './popup-nqt.component.html',
  styleUrls: ['./popup-nqt.component.scss']
})
export class PopupNhomQuanTriComponent implements OnInit {
  @Input() dataTransmission: any;
  isEditMode = false;
  province = new Province();
  ProvinceCodeControl = new FormControl('');
  ProvinceNameControl = new FormControl('');
  errorMsg: string;
  isDisabled = false;
  validateForm!: FormGroup;
  group = new GroupManage();
  ListEnum : any;
  constructor(
    private modal: NzModalRef,
    private msg: NzMessageService,
    private route: ActivatedRoute,
    public utilsService: UtilsService,
    private service: GroupManagerService,
    private fb: FormBuilder
  ) {
   
  }

  ngOnInit() {
    if (this.dataTransmission && this.dataTransmission.id > 0) {
      this.GetById(this.dataTransmission.id);
      this.isEditMode = true;
    } else {
      this.group = new GroupManage();
      this.isEditMode = false;
    }
    this.getnEnum();
  }
  getnEnum(){
    this.service.getGetDisEducationAndTrainingFor(this.ListEnum).subscribe((res)=>{
      this.ListEnum = res;
    })
  }
  GetById(id : number){
    this.service.getGroupById(id).subscribe((res)=>{
      this.group = res;
    })
  }
  close() {
    this.destroyModal();
  }
  destroyModal(): void {
    this.modal.destroy(true);
  }
  UpdateClose(){
    this.group.isAdmin = true;
    if(this.group.groupCode && this.group.groupCode !== '' && this.group.groupName && this.group.groupName !== '' ){ 
      this.service.addOrUpdateGroupManage(this.group).subscribe((res)=>{
        if(res.statusCode == 0){
          this.utilsService.notifyResponse(res);
          this.close();
        }
        else{
          this.utilsService.notifyResponse(res);
        }
      })
    }else{
      this.msg.warning('Vui lòng nhập Mã và Tên!')
    }
  }
  
}
